import React, { useContext } from "react";
import "./home-style.css";
import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const CardSection = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.cardSection : jsonDataFr.data.cardSection;
  return (
    <section className="card-section">
      <div className="card-section__inner">
        <h2 className="card-section__title">{data.title}</h2>

        <div className="card-grid">
          {/* Card 1 */}
          <article className="glass-card">
            <img src="assets/home/Intimidated Beginners.svg" alt="Intimidated Beginners" className="card-icon" />
            <h3 className="glass-card__title">{data.card1Title}</h3>
            <p className="glass-card__desc">{data.card1Description} </p>
          </article>

          {/* Card 2 */}
          <article className="glass-card">
            <img src="assets/home/Missed Trainer Leads.svg" alt="Missed Trainer Leads" className="card-icon" />
            <h3 className="glass-card__title">{data.card2Title}</h3>
            <p className="glass-card__desc">{data.card2Description} </p>
          </article>

          {/* Card 3 */}
          <article className="glass-card">
            <img src="assets/home/Frustrating Online Plans.svg" alt="Frustrating Online Plans" className="card-icon" />
            <h3 className="glass-card__title">{data.card3Title}</h3>
            <p className="glass-card__desc">{data.card3Description} </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default CardSection;
